module.exports = __webpack_public_path__ + "static/img/user-left.cd6274c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/user-left.png
// module id = RsMp
// module chunks = 1